import {
  GET_TRIGGER_ORDER_QUOTE,
  GET_TRIGGER_ORDER_QUOTE_SUCCESS,
  GET_TRIGGER_ORDER_QUOTE_ERROR,
  GET_TRIGGER_ORDER_DETAILS,
  GET_TRIGGER_ORDER_DETAILS_SUCCESS,
  GET_TRIGGER_ORDER_DETAILS_ERROR,
  EXECUTE_TRIGGER_ORDER_QUOTE,
  EXECUTE_TRIGGER_ORDER_QUOTE_SUCCESS,
  EXECUTE_TRIGGER_ORDER_QUOTE_ERROR,
  CANCEL_TRIGGER_ORDER,
  CANCEL_TRIGGER_ORDER_SUCCESS,
  CANCEL_TRIGGER_ORDER_ERROR,
  REQUEST_TARGET_PRICE_AGAIN,
  FINISH_TARGET_PRICE_AGAIN,
  TARGET_PRICE_AGAIN_STATUS,
} from './triggerOrdersActionConstants';

// payload: { productCode, locationType, isSegregated } of the expired order. The
// request is stamped with when it was made (it is only carried out while fresh,
// so one that waits on products that never load can't open the flow later, and
// the modal that made it can tell it from any other) and starts out pending.
export const requestTargetPriceAgain = (payload) => ({
  type: REQUEST_TARGET_PRICE_AGAIN,
  payload: {
    ...payload,
    requestedAt: Date.now(),
    status: TARGET_PRICE_AGAIN_STATUS.PENDING,
  },
});

// payload: how the request ended, a TARGET_PRICE_AGAIN_STATUS other than pending.
export const finishTargetPriceAgain = (payload) => ({
  type: FINISH_TARGET_PRICE_AGAIN,
  payload,
});

export const getTriggerOrderQuote = (payload) => ({
  type: GET_TRIGGER_ORDER_QUOTE,
  payload,
});

export const getTriggerOrderQuoteSuccess = (payload) => ({
  type: GET_TRIGGER_ORDER_QUOTE_SUCCESS,
  payload,
});

export const getTriggerOrderQuoteError = (payload) => ({
  type: GET_TRIGGER_ORDER_QUOTE_ERROR,
  payload,
});

export const getTriggerOrderDetails = (payload) => ({
  type: GET_TRIGGER_ORDER_DETAILS,
  payload,
});

export const getTriggerOrderDetailsSuccess = (payload) => ({
  type: GET_TRIGGER_ORDER_DETAILS_SUCCESS,
  payload,
});

export const getTriggerOrderDetailsError = (payload) => ({
  type: GET_TRIGGER_ORDER_DETAILS_ERROR,
  payload,
});

export const executeTriggerOrderQuote = (payload) => ({
  type: EXECUTE_TRIGGER_ORDER_QUOTE,
  payload,
});

export const executeTriggerOrderQuoteSuccess = (payload) => ({
  type: EXECUTE_TRIGGER_ORDER_QUOTE_SUCCESS,
  payload,
});

export const executeTriggerOrderQuoteError = (payload) => ({
  type: EXECUTE_TRIGGER_ORDER_QUOTE_ERROR,
  payload,
});

export const cancelTriggerOrder = (payload) => ({
  type: CANCEL_TRIGGER_ORDER,
  payload,
});

export const cancelTriggerOrderSuccess = (payload) => ({
  type: CANCEL_TRIGGER_ORDER_SUCCESS,
  payload,
});

export const cancelTriggerOrderError = (payload) => ({
  type: CANCEL_TRIGGER_ORDER_ERROR,
  payload,
});
